module.exports = __webpack_public_path__ + "assets/img/Type E (30).96f7523b.jpg";